// Add your custom JS here.
// import { slick } from "slick-carousel";
require("slick-carousel");

// Tagline objects per page
const taglines = document.querySelectorAll(".tagline");

const span = "<span style='opacity:0;'>";
const spanEnd = "</span>";

let text = "";
// Letter counter index
let j = 0;
//Tagline tracker (Which tagline we are at from all taglines of the page)
let i = 0;
//All Taglines in array to store the original state before slicing them
const allTaglines = [];
const allObjects = [];
let home = false;
// Populating the array
if (taglines != null) {
  for (let index = 0; taglines.length > index; index++) {
    allTaglines.push(taglines[index].innerText);
    allObjects.push(taglines[index]);
  }
}

// The actual magic
function spanStepper() {
  let origiText = "";
  // Prepares the current tagline via i index
  if (i < taglines.length) {
    origiText = allTaglines[i];
  } else {
    i = 0;
    origiText = allTaglines[i];
  }

  // Basically a loop. Gets the current tagline and slice it in a way that it basocally moves a <span> tag down the way which has an opacity value of 0
  if (j < origiText.length) {
    text =
      origiText.slice(0, j) +
      span +
      origiText.slice(j, origiText.length - 1) +
      spanEnd;
    // Checks if its homepage slider or eleswhere
    if (document.getElementById("tagline")) {
      home = true;
      document.getElementById("tagline").innerHTML = text;
    } else {
      taglines[i].innerHTML = text;
    }
    j++;
    // Delay between the characters with random value introduced
    setTimeout(spanStepper, 100 * Math.random());
  } else {
    // Once it's complete it adds a fade out effect with opacity 0. Animation via css transition rule
    setTimeout(wholeTextOpacity, 2000);
  }
}
// The actual fadeOut effect
function wholeTextOpacity() {
  if (home) {
    document.getElementById("tagline").style["opacity"] = "0";
  }
  // Prepares the next tagline to continue
  setTimeout(nextText, 500);
}

function nextText() {
  // Resets the opacity of the field
  if (home) {
    document.getElementById("tagline").style["opacity"] = "1";
  }
  // Increases the allTaglines index to continue with the next tagline
  i++;
  // resets the character per tagline counter
  j = 0;
  // Restarts the magic
  spanStepper();
}
if (document.querySelectorAll(".tagline").length > 0) {
  spanStepper();
}
if (document.getElementById("mute-button")) {
  document.getElementById("mute-button").addEventListener("click", function () {
    this.classList.toggle("bi-volume-up-fill");
    this.classList.toggle("bi-volume-off-fill");

    var video = document.getElementById("about-video");
    if (video.muted) {
      video.muted = false;
    } else {
      video.muted = true;
    }
  });
}
if (document.getElementById("show-all")) {
  document.getElementById("show-all").addEventListener("click", function (e) {
    const accordions = document
      .getElementById("accordionProjectsIndex")
      .querySelectorAll(".accordion-collapse");
    accordions.forEach((element) => element.classList.add("show"));
    document.getElementById("show-all").classList.toggle("d-none");
    document.getElementById("hide-all").classList.toggle("d-none");
  });
}
if (document.getElementById("hide-all")) {
  document.getElementById("hide-all").addEventListener("click", function (e) {
    const accordions = document
      .getElementById("accordionProjectsIndex")
      .querySelectorAll(".accordion-collapse");
    accordions.forEach((element) => element.classList.remove("show"));
    document.getElementById("show-all").classList.toggle("d-none");
    document.getElementById("hide-all").classList.toggle("d-none");
  });
}

(function ($) {
  $(document).on("ready", function () {
    // BS5 CAROUSEL CONTROL
    $("img").on("click", function (e) {
      if (e.currentTarget.dataset.shadowslide) {
        let targetSlide = e.currentTarget.dataset.shadowslide;
        document
          .getElementById("carouselGalleryControls")
          .classList.remove("d-none");
        let slides = document
          .getElementById("carouselGalleryControls")
          .querySelectorAll(".carousel-item");
        for (let i = 0; slides.length > i; i++) {
          if (i == targetSlide) {
            slides[i].classList.add("active");
          } else {
            slides[i].classList.remove("active");
          }
        }
        document.body.classList.add("overflow-hidden");
      }
    });
    $("#project-carousel-close").on("click", function () {
      document
        .getElementById("carouselGalleryControls")
        .classList.add("d-none");
      document.body.classList.remove("overflow-hidden");
    });

    // BS5 CAROUSEL END

    // DRAWINGS CAROUSEL
    $("#drawings").on("click", function (e) {
      document
        .getElementById("carouselDrawingsControls")
        .classList.remove("d-none");
      document.body.classList.add("overflow-hidden");
    });
    $("#drawings-carousel-close").on("click", function () {
      document
        .getElementById("carouselDrawingsControls")
        .classList.add("d-none");
      document.body.classList.remove("overflow-hidden");
    });
    // DRAWINGS CAROUSEL END

    $(".team-slick").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
    });

    $(".related-slide").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
    });

    if (document.body.classList.contains("home")) {
      $(".carousel").slick({
        dots: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: "linear",
        infinite: true,
        variableWidth: false,
        pauseOnHover: false,
      });
    }

    let index = 0;
    let hi = 0;
    let theText = "";
    if (document.body.classList.contains("home")) {
      theText = document
        .querySelector(".slick-active")
        .querySelector(".tagline-home").innerText;
    } else {
      theText = "";
    }
    if (document.body.classList.contains("home")) {
      homeTagChanger();
    }

    function homeTagChanger() {
      document.getElementById("home-tagline").innerHTML =
        theText.toString().substring(0, index + 1) +
        span +
        theText.toString().substring(index + 1, theText.length) +
        spanEnd;
      if (document.body.classList.contains("home")) {
        if (index < theText.length) {
          setTimeout(homeTagChanger, 50);
        }
        index++;
      }
    }

    $(".carousel").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        document.getElementById("home-tagline").innerHTML = "";
      }
    );

    $(".carousel").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        theText = $(".tagline-home")[currentSlide].innerText;
        index = 0;
        homeTagChanger();
      }
    );

    $(".tagline-slider-container").slick({
      dots: false,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: "linear",
      infinite: true,
      variableWidth: false,
    });
  });
})(jQuery);
